<div class="reparability-label"
     *ngIf="repairability && (repairability | json) != '{}'"
>
  <a
    class="energy_label__product-file-link"
    [href]="repairability.src"
    target="_blank"
    rel="noopener noreferrer"
    (click)="onRepairabilityLabelClick($event)"
  >
    <img [src]="repairability.imageUrl" [title]="repairability.label" [alt]="repairability.index"
        class="repairability"  [ngClass]="{'label-img': isImageHasLabel}"/>
  </a>
</div>
